<template lang="pug">
  .Recommendation
    top-informations(title="个性化推荐" subtitle="所需即所见" text="You see, you need" )
    project-design(text="基于业界领先的大数据和人工智能技术，面向信息流、广告等业务场景，帮助企业实现对用户“千人千面”的自动化、实时、个性化精准推荐，只需进行简单的API调用，即可快速拥有业界顶尖的推荐服务能力。")
    framework(:framework="framework")
    core-tech(:text="coreTechText" :core-tech="coreTechList")
    .background
      customers(:customers="customers")
      scene(:scenes="['数字教育', '数字旅游', '数字医疗']")
</template>

<script>
  import TopInformations from "@/views/Solution/components/TopInformations/TopInformations";
  import ProjectDesign from "@/views/Solution/components/ProjectDesign/ProjectDesign";
  import Framework from "@/views/Solution/components/Framework/Framework";
  import Customers from "@/views/Solution/components/customers/customers";
  
  // import framework from "@/assets/images/个性化架构图.png";
  const framework = 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E6%9E%B6%E6%9E%84%E5%9B%BE/%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-%E4%B8%AA%E6%80%A7%E5%8C%96%E6%8E%A8%E8%8D%90.png';
  import CoreTech from "@/views/Solution/components/coreTech/coreTech";
  
  import tech1 from '@/assets/images/强大的推荐算法能力.png';
  import tech2 from '@/assets/images/实时采集能力.png';
  import tech3 from '@/assets/images/轻松搭建推荐系统.png';
  import tech4 from '@/assets/images/全流程自动监控.png';
  import tech5 from '@/assets/images/团队赋能.png';
  import tech6 from '@/assets/images/私有化一键部署.png';
  import Scene from "@/views/Solution/components/Scene/Scene";
  
  import customer1 from '@/assets/images/推荐算法开发者.png';
  import customer2 from '@/assets/images/推荐算法系统使用者.png';
  import customer3 from '@/assets/images/推荐系统使用者.png';
  
  export default {
    name: "Recommendation",
    components: {Customers, Scene, CoreTech, Framework, ProjectDesign, TopInformations},
    props: {},
    data() {
      return {
        framework,
        coreTechText:
          '全自动处理、分析与洞察多模态内容，深入理解内容背后的含义，发掘与识别最有价值的热点内容。\n多维度挖掘用户长短期兴趣画像，精准把握用户偏好诉求，融合多种算法模型，突破传统推荐平台单调重复的问题，改善用户体验，持续提升核心业务指标。',
        coreTechList: [
          {img: tech1, title: "强大的推荐算法能力", text: '提供强大的深度学习算法套件，保证商品与用户的高度精准匹配'},
          {img: tech2, title: "实时采集、更新、推荐能力", text: '实时采集用户线上行为、更新用户画像、持续优化推荐算法'},
          {img: tech3, title: "轻松搭建推荐系统", text: '提供推荐系统可视化建模工具，实现推荐系统个性化定制、5min上手搭建推荐系统'},
          {img: tech4, title: "全流程自动监控，零运维成本", text: '覆盖数据接入、推荐模型构建、推荐服务上线全流程，实现全流程各环节自动监控，极大降低企业运维成本'},
          {img: tech5, title: "团队赋能", text: '提供推荐系统方案培训，赋能企业算法团队'},
          {img: tech6, title: "私有化一键部署", text: '保障企业数据隐私安全'},
        ],
        customers: [
          {img: customer1, title: '推荐算法开发者', text: '推荐系统底层开发SDK\n(Http API接口调用)'},
          {img: customer2, title: '推荐算法开发者&系统使用者', text: '推荐服务调用SDK\n(Http API接口调用)'},
          {img: customer3, title: '推荐系统使用者', text: '移动端/PC H5\n(推荐系统模板+Http API)'},
        ],
      };
    },
    watch: {},
    computed: {},
    methods: {},
    created() {
    },
    mounted() {
    },
  };
</script>

<style scoped lang="stylus">
  @import "../index.styl"
  .Recommendation {
    /deep/ .coreTech {
      > div {
        max-width 1326px
        
        > .card {
          width 400px
        }
      }
    }
    
    .background {
      background url("../../../assets/images/56156464.png") repeat-x
      background-position 0 0
      animation: backgroundMove 10s infinite linear;
    }
  }
  
  @keyframes backgroundMove {
    0% {
      background-position 0 0
    }
    100% {
      background-position -2784px 0
    }
  }
  /deep/.coreTech {
    > div p {
      width 330px
    }
  }
  @media (max-width: screenWidth) {
    .Recommendation {
      /deep/.coreTech {
        > div {
          .card {
            width 75%;
          }
          p {
            width auto
          }
        }
      }
      .background {
        background none
      }
    }
  }
</style>
